module.exports = __webpack_public_path__ + "img/hr-curved-rail-horizontal-right-bottom-stone-path-background.98999d15.png";